import { render, staticRenderFns } from "./WorkOrderLockBanner.vue?vue&type=template&id=4b7c6078&scoped=true"
import script from "./WorkOrderLockBanner.vue?vue&type=script&lang=js"
export * from "./WorkOrderLockBanner.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderLockBanner.vue?vue&type=style&index=0&id=4b7c6078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7c6078",
  null
  
)

export default component.exports